import Search from "./Search";

const HomePage = () => {
  return (
    <div>
      <h1>SpotiApp</h1>
      <Search />
    </div>
  );
};

export default HomePage;
